/* eslint no-console:0 */

/**
 * ログ出力定義
 */
export const Level = {
  NONE: 'none',
  ERROR: 'error',
  WARN: 'warn',
  INFO: 'info',
  DEBUG: 'debug',
  TRACE: 'trace',
} as const

export default class ConsoleLogger {
  // ログレベル
  map: Map<string, number> = new Map([
    [Level.NONE, 100],
    [Level.ERROR, 50],
    [Level.WARN, 40],
    [Level.INFO, 30],
    [Level.DEBUG, 20],
    [Level.TRACE, 10],
  ])

  /**
   * コンストラクタ
   * @param level ログレベル
   */
  constructor(private level?: string) {
    if (level !== undefined) {
      this.level = level
    } else {
      this.level = Level.INFO
    }
  }

  /**
   * エラーログを出力
   * @param msg メッセージ
   */
  error(msg: string): void {
    if (this.isLevel(Level.ERROR)) {
      console.error(ConsoleLogger.log(msg, Level.ERROR))
    }
  }

  /**
   * 警告ログを出力
   * @param msg メッセージ
   */
  warn(msg: string): void {
    if (this.isLevel(Level.WARN)) {
      console.warn(ConsoleLogger.log(msg, Level.WARN))
    }
  }

  /**
   * 情報ログを出力
   * @param msg メッセージ
   */
  info(msg: string): void {
    if (this.isLevel(Level.INFO)) {
      console.info(ConsoleLogger.log(msg, Level.INFO))
    }
  }

  /**
   * デバッグログを出力
   * @param msg メッセージ
   */
  debug(msg: string): void {
    if (this.isLevel(Level.DEBUG)) {
      console.log(ConsoleLogger.log(msg, Level.DEBUG))
    }
  }

  /**
   * トレースログを出力
   * @param msg メッセージ
   */
  trace(msg: string): void {
    if (this.isLevel(Level.TRACE)) {
      console.log(ConsoleLogger.log(msg, Level.TRACE))
    }
  }

  /**
   * 出力メッセージを取得する
   * @param msg メッセージ
   * @param level ログレベル
   */
  static log(msg: string, level: string): string {
    return `${ConsoleLogger.date()} [${level.toUpperCase()}] ${msg}`
  }

  /**
   * ログレベルの判定
   * @param level レベル文字列
   */
  private isLevel(level: string): boolean {
    const target: number = this.map.get(level) as number
    const now: number = this.map.get(this.level as string) as number
    return target >= now
  }

  /**
   * 時刻を取得する
   */
  static date(): string {
    const date = new Date()

    const year = date.getFullYear().toString().padStart(4, '0')
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const day = date.getDate().toString().padStart(2, '0')
    const hours = date.getHours().toString().padStart(2, '0')
    const minutes = date.getMinutes().toString().padStart(2, '0')
    const secounds = date.getSeconds().toString().padStart(2, '0')
    const milli = date.getMilliseconds().toString().padStart(3, '0')

    return `${year}/${month}/${day} ${hours}:${minutes}:${secounds}.${milli}`
  }
}
